import { Modal } from '@carbon/react';
import { defineMessages, useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';
import { useRemoveUserFromEntityMutation } from 'api/entityEndpoints';
import useGetCurrentEntityId from 'hooks/useGetCurrentEntityId';

type Props = {
    id: string;
    onModalClose: () => void;
    confirmationModalOpen: boolean;

}

const RemoveTeamMemberModal = ({
    id,
    onModalClose,
    confirmationModalOpen,
}: Props) => {
    const intl = useIntl();
    const currentEntityId = useGetCurrentEntityId();
    const [remove, { isLoading }] = useRemoveUserFromEntityMutation();

    const onRemove = async () => {
        if (!currentEntityId) {
            return;
        }

        await remove({ entityId: currentEntityId, userIdToRemove: id }).unwrap();
        onModalClose();
    };

    return (
        <Modal
            open={confirmationModalOpen}
            onRequestClose={onModalClose}
            onRequestSubmit={onRemove}
            primaryButtonDisabled={isLoading}
            danger
            modalHeading={intl.formatMessage(messages.areYouSure)}
            modalLabel={intl.formatMessage(messages.removingFromOrg)}
            primaryButtonText={intl.formatMessage(sharedMessages.remove)}
            closeButtonLabel={intl.formatMessage(sharedMessages.cancel)}
            secondaryButtonText={intl.formatMessage(sharedMessages.back)}
        />
    );
};

const messages = defineMessages({
    removingFromOrg: {
        id: 'src.Screens.Dashboard.Team.Components.TeamCellHandler.TeamInteractions.Interactions.Interactions.RemoveTeamMemberModal.removingFromOrg',
        defaultMessage: 'Usuń z organizacji',
    },
    areYouSure: {
        id: 'src.Screens.Dashboard.Team.Components.TeamCellHandler.TeamInteractions.Interactions.Interactions.RemoveTeamMemberModal.areYouSure',
        defaultMessage: 'Jesteś pewien, że chcesz usunąć członka organizacji? Ta operacja jest nieodwracalna.',
    },
});

export default RemoveTeamMemberModal;
